<template>
    <nuxt-link class="personal-button" to="/personal/" v-if="userStore.user">{{userStore.user.firstName}}</nuxt-link>
    <a class="personal-button" href="/login/" v-else @click.prevent="show = true">Войти в личный кабинет</a>
    <client-only>
        <lazy-ui-popup v-model="show" :width="520" code="login-form" title="Вход на сайт">
            <lazy-pages-login-email-form v-if="type" @switch="type = !type"></lazy-pages-login-email-form>
            <lazy-pages-login-phone-form v-else @switch="type = !type"></lazy-pages-login-phone-form>
        </lazy-ui-popup>
    </client-only>
</template>

<script setup lang="ts">
import { useUserStore } from '~/store/userStore';


const userStore = useUserStore();
const show = ref(false);
const type = ref(false);

const route = useRoute();

watch([() => route.fullPath, () => userStore.user], () => {
    show.value = false;
});

</script>

<style lang="scss" scoped>

.personal-button {
    background-color: rgba(255,255,255,.07);
    padding: 0 32px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 450;

    @media (max-width: 1250px) {
        padding: 0 14px;
    }

    &:hover {
        background-color: rgba(255,255,255,.14);
    }

    &.nuxt-link-active {
        background-color: rgba(255,255,255,.25);
    }
}

</style>